var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSubNavlinkBorder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 70,
  height: 4,
  viewBox: "0 0 70 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#427CBE",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeDasharray: "15 15",
  d: "M2 2h66"
})));
export { SvgSubNavlinkBorder as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzAiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDcwIDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxsaW5lIHgxPSIyIiB5MT0iMiIgeDI9IjY4IiB5Mj0iMiIgc3Ryb2tlPSIjNDI3Q0JFIiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWRhc2hhcnJheT0iMTUgMTUiLz4KPC9zdmc+Cg==";